import React__default from 'react';

/**
 * Render the navigation dropdowns for the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function DropdownNav(props) {
    return React__default.createElement("div", { ...props });
}

export { DropdownNav };
